import { inject, Injectable } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { AdditionalRatesStore } from '../additional-rates/additional-rates.store';
import { AdditionalRateType } from '../../models/additional-rate-type.model';
import { AdditionalRatesService } from '../../services/additional-rates.service';
import { take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdditionalRatesEffects {
    private readonly additionalRatesStore = inject(AdditionalRatesStore);
    private readonly additionalRatesService = inject(AdditionalRatesService);

    getAdditionalRateTypes(): void {
        this.additionalRatesService
            .getAdditionalRateTypes()
            .pipe(
                take(1),
                tapResponse({
                    next: (data: AdditionalRateType[]) => {
                        this.additionalRatesStore.updateAdditionalRateTypes(data);
                    },
                    error: () => {
                        this.additionalRatesStore.updateAdditionalRateTypes([]);
                    }
                })
            )
            .subscribe();
    }

    getMarginCoverageTypes(): void {
        this.additionalRatesService
            .getMarginCoverageTypes()
            .pipe(
                take(1),
                tapResponse({
                    next: (data) => {
                        this.additionalRatesStore.updateMarginCoverageTypes(data);
                    },
                    error: () => {
                        this.additionalRatesStore.updateMarginCoverageTypes([]);
                    }
                })
            )
            .subscribe();
    }
}
